import styled, { css } from 'styled-components';
import React from 'react';

const ImageButtonWrap = styled.img<ImageButtonStyleProps>`
  cursor: pointer;
  width: ${(props) => (props.width ? props.width : '100%')};
  height: ${(props) => (props.height ? props.height : '51px')};
  border: ${(props) => (props.border ? props.border : 'none')};
  border-radius: ${(props) => (props.borderRadius ? props.borderRadius : 'none')};
  max-width: ${(props) => (props.maxWidth ? props.maxWidth : '')};


  ${(props) =>
    props.display &&
    css`
      display: ${props.display};
    `}
`;

export interface ImageButtonStyleProps {
  borderRadius?: string;
  fontSize?: string;
  backgroundColor?: string;
  active?: boolean;
  border?: string;
  height?: string;
  width?: string;
  display?: string;
  maxWidth?: string;
}

interface ImageButtonProps {
  onClick: (e: React.MouseEvent) => void;
  imgSrc?: string;
  className?: string;
  styles?: ImageButtonStyleProps;
}

const ImageButton = (props: ImageButtonProps) => {
  const { onClick, styles = {}, className, imgSrc } = props;

  return (
    <ImageButtonWrap className={className} onClick={onClick} {...styles} src={imgSrc}>
    </ImageButtonWrap>
  );
};

export default ImageButton;
